import { render, staticRenderFns } from "./leftSelect.vue?vue&type=template&id=32bf77da&"
import script from "./leftSelect.ts?vue&type=script&lang=js&"
export * from "./leftSelect.ts?vue&type=script&lang=js&"
import style0 from "./leftSelect.vue?vue&type=style&index=0&id=32bf77da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports